import { render } from "./ScrollContainer.vue?vue&type=template&id=16dbcd8a"
const script = {}

import "./ScrollContainer.vue?vue&type=style&index=0&id=16dbcd8a&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__